import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { UtilityService } from '../../../services/utility-service';
import { Location } from '@angular/common';
import { ErrorService } from '../../../shared/error-page/service/error-service';
import { TransactionWrapper } from '../../../../../src/app/model/transactionWrapper';
import { Constants } from '../../../../../src/app/constants/ebtq-constants';
import { TransactionWrapperData } from '../../../../../src/app/model/transactionWrapperData';
import { LoanDetailWrapper } from '../../../../../src/app/model/loanDetailWrapper';
import {Title} from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-query-loan-details',
  templateUrl: './query-loans-details.component.html',
  styleUrls: ['./query-loans-details.component.scss']
})
export class QueryLoanDetailsComponent implements OnInit, OnDestroy {
  private errorSub: Subscription;
  loanNumber: string;
  containsError = false;
  errorMsg: string;
  responseDetails: LoanDetailWrapper;
  fhaCaseNumber: string;
  data: any;
  transactionWrapper: TransactionWrapper;
  loanDetailWrapper: LoanDetailWrapper;
  transactionWrapperData: TransactionWrapperData;
  keys: any[];
  mainPage: string;
  loanResultKeys: any;
  isExternal:boolean;
  subPage: string;
  title = 'Loan Details';

  constructor(private router: ActivatedRoute, private service: ApiService, private routerCore: Router,
              private errorService: ErrorService, private utilService: UtilityService, private location: Location,
              private titleService: Title, private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');

    /** Receive loan Number from last navigation */
    this.router.queryParams.subscribe(params => {
      this.loanResultKeys = params.loanResult;
      this.loanNumber = params.loanNumber;
      this.keys = params.query;
      this.mainPage = params.mainPage;
      this.subPage = params.subPage;
      this.getloanDetail(this.loanNumber);
    });


    this.isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    this.cdr.detectChanges();
  }
  /** cancel button - get back to result page */
  public cancel() {
    // this.location.back();
    if (this.mainPage === 'queryTransactions' ) {
      this.location.back();
    }
    if (this.mainPage === 'transactions') {
      this.routerCore.navigate(['transactions'], { queryParams: {subPage:this.subPage}});
    }
    if (this.mainPage === 'QueryLoan') {
      this.routerCore.navigate(['queryLoansResult'], {
        queryParams: { query: btoa(JSON.stringify(this.keys)),
          mainPage: this.mainPage, loanResult:this.loanResultKeys,
          subPage:this.subPage}
      });
    }
  }
  /** Detailed page print view*/
  public printComponent() {
    window.print();
  }
  /** Call backend API to get the loan details */
  getloanDetail(loanNumber: string) {
    this.transactionWrapper = new TransactionWrapper();
    this.transactionWrapper.queryServiceName = Constants.GET_LOAN_DETAIL;
    this.transactionWrapper.parameters[0] = loanNumber;
    this.service.getQueryLoanDetailResult(this.transactionWrapper).subscribe(
      (data: LoanDetailWrapper) => {
        this.loanDetailWrapper = data;
        this.responseDetails = this.formatloanDetail(data);
        this.responseDetails;
        this.cdr.detectChanges();
      },
      error => {
        this.errorService.announceError(error);
      }
    );
    this.errorAnnouncement();
  }

  errorAnnouncement() {
    // error announcement
    this.errorSub = this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.errorSub) {
      this.errorSub.unsubscribe();
    }
  }

  /** Format the API response to readable format */
  formatloanDetail(response: LoanDetailWrapper): LoanDetailWrapper {
    /** Convert convertMillisecToDate */
    if (response.fundingDate != null) {
      response.fundingDate = this.utilService.convertMillisecToDate(response.fundingDate);
    }
    if (response.purchaseDate != null) {
      response.purchaseDate = this.utilService.convertMillisecToDate(response.purchaseDate);
    }
    if (response.nextAdjDate != null) {
      response.nextAdjDate = this.utilService.convertMillisecToDate(response.nextAdjDate);
    }
    if (response.closingDate != null) {
      response.closingDate = this.utilService.convertMillisecToDate(response.closingDate);
    }
    if (response.borrowersDOB != null) {
      response.borrowersDOB = this.utilService.convertMillisecToDate(response.borrowersDOB);
    }
    /** Convert amount value to float */
    if (response.interestRate != null) {
      response.interestRate = parseFloat(response.interestRate).toFixed(3);
    }
    /** Convert amount value to float */
    if (response.mortgageMargin != null) {
      response.mortgageMargin = parseFloat(response.mortgageMargin).toFixed(2);
    }
    /** Get the label value from utilService */
    this.utilService.productCode.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.productType)) {
        response.productType = array1[index1].label;
      }
    });

    /** Get the label value from utilService */
    this.utilService.actionTypeCode.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanStatus)) {
        response.loanStatus = array1[index1].label;
      }

    });

    this.utilService.detailSchdPaymentStatus.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.schdPymntStatus)) {
        response.schdPymntStatus = array1[index1].label;
      }

    });

    /** Get the label value from utilService */
    this.utilService.queryLoanPaymentPln.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.paymentPlan)) {
        response.paymentPlan = array1[index1].label;
      }
    });
    /** Get the label value from utilService */
    this.utilService.inrateType.forEach(function(part1, index1, array1) {
      if (response.intRateType != null) {
        if (array1[index1].value === String(response.intRateType)) {
          response.intRateType = array1[index1].label;
        }
      }
    });

    return response;
  }
  showloanDetailWrappers() {
    this.routerCore.navigate(['queryTransactions'], {
      queryParams: { loanNumber: this.loanNumber, Keys: this.keys, mainPage: this.mainPage, loanResult:this.loanResultKeys, fromPerformTrans: true, subPage:this.subPage}
    });
  }
}

